import {
  BranchIcon,
  ChartIcon,
  CrmIcon,
  HoldingsIcon,
  RupeeIcon,
} from "components";
import Highcharts from "highcharts/highstock";
import exporting from "highcharts/modules/exporting";
import { useState } from "react";
import { useAppSelector } from "store/store";
import { AUMS_AGGREGATE } from "utils/apiRoutes";
import { moneyCommaSeparatorPoint, numberToCurrency } from "utils/MathFunction";
import { QueryKeys } from "utils/queryKey";
import { useFetchQuery } from "./useQueries";

exporting(Highcharts);

export const useDashboard = () => {
  const [isPortfolioTab, setIsPortfolioTab] = useState(0);
  const [isCurrentTab, setIsCurrentTab] = useState(0);
  const [partnerSelection, setPartnerSelection] = useState([]);

  const partnerList = useAppSelector((state) => state?.app?.partnerList);

  const { data: AUMData, isLoading: isCardsLoading } = useFetchQuery({
    key: [QueryKeys.DASHBOARD_AUMS, partnerSelection],
    route: AUMS_AGGREGATE,
    requestBody: {
      partners: JSON.stringify(partnerSelection),
    },
  });

  const { data: LineChart, isLoading: isLineLoading } = useFetchQuery({
    key: ["GET_LINECHART_DATA", partnerSelection],
    route: `/aums/timeline/`,
    requestBody: {
      partners: JSON.stringify(partnerSelection),
    },
  });

  const convertedData = [
    {
      id: 1,
      name: "Assets Under Management",
      value: numberToCurrency(AUMData?.data?.cards?.aum) || "-",
      icon: ChartIcon,
    },
    {
      id: 2,
      name: `Equity`,
      value: numberToCurrency(AUMData?.data?.cards?.equity) || "-",
      icon: HoldingsIcon,
    },
    {
      id: 3,
      name: `Cash`,
      value: numberToCurrency(AUMData?.data?.cards?.cash) || "-",
      icon: RupeeIcon,
    },
    {
      id: 3,
      name: `Portfolios`,
      value: moneyCommaSeparatorPoint(AUMData?.data?.cards?.portfolios) || "-",
      icon: BranchIcon,
    },
    {
      id: 4,
      name: "Clients ",
      value: moneyCommaSeparatorPoint(AUMData?.data?.cards?.clients) || "-",
      icon: CrmIcon,
      name_2: "Portfolios ",
      value_2: AUMData?.data?.cards?.portfolios || "-",
    },
  ];

  const returnTopTenData = (isPortfolioTab: number) => {
    switch (isPortfolioTab) {
      case 0:
        return AUMData?.data?.top10?.portfolios;
      case 1:
        return AUMData?.data?.top10?.clients;

      default:
        return [];
    }
  };
  const loading = isLineLoading || isCardsLoading;

  return {
    convertedData,
    AUMData,
    loading,
    isPortfolioTab,
    setIsPortfolioTab,
    isCurrentTab,
    setIsCurrentTab,
    returnTopTenData,
    LineChart,
    partnerSelection,
    setPartnerSelection,
    partnerList,
  };
};
